import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getRolesByAN8 = async (username) => {
  console.log(localStorage);

  // const token = localStorage.getItem('initToken');
  const token = await authHeader();
  const url = `${ baseUrl }/roles/${username}`;
  
  return axios.get(url,
  {headers: {
    Authorization: 'Bearer ' + token
}}
  ).then(
      (response) => {
    return response.data;
  })
};

const getRoleById = async(idRol) => {

  const token = await authHeader();
  const url = `${ baseUrl }/rol/findById/${idRol}`;
  
  return axios.get(url,
  {headers: token}
  ).then(
      (response) => {
    return response.data;
  })
};

const getAllRoles = async() => {
  const token = await authHeader();
  const url = `${ baseUrl }/rol/findAll`;
  return axios
    .get(url, {
      headers: token
    }
      ).then(response => {
      console.log(response.data)
      return response.data;
     }
     )
};

const createRole = async(roleData) => {
  const token = await authHeader();
  const url = `${ baseUrl }/rol/create`;
return axios.post(url, roleData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

const updateRole = async(roleData, idRol) => {
  const token = await authHeader();
  const url = `${ baseUrl }/rol/update/${idRol}`;
return axios.put(url, roleData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

const getPermissionsList = async() => {

  const token = await authHeader();
  const url = `${ baseUrl }/permission/find-all`;
  
  return axios.get(url,
  {headers: token
  }
  ).then(
      (response) => {
    return response.data;
  })
};

export default {
    getRolesByAN8,
    getRoleById,
    getAllRoles,
    createRole,
    updateRole,
    getPermissionsList
};